import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { Observable } from 'rxjs';
import { Rol } from '../model/rol.model';
import { User } from '../model/user.model';
import { Paginated } from '@core/model/paginated.model';
// import { environment } from '@env/environment.prod';
import { map, shareReplay } from 'rxjs/operators';
import { confPaginated } from '../constants/paginacion.const';

@Injectable()
export class UserService extends BaseAPIClass {
  // baseUrl = environment.serverBaseUrl;

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/users';
  }

  getAllRoles(): Observable<Rol[]> {
    return this.httpClient.get<Rol[]>(this.baseUrl + '/roles').pipe(
      map(value => {
        console.log(value);
        return value;
      }),
      shareReplay(1)
    );
  }

  getRoles(): Observable<Rol[]> {
    return this.httpClient.get<Rol[]>(this.baseUrl + '/rol');
  }

  enableUser(id: number) {
    return this.httpClient.get(
      this.baseUrl +
        '/habilitar/' +
        id +
        `?user_id=${JSON.parse(localStorage.getItem('credentials')).user.id}`
    );
  }

  // users/suscripcion/{id}
  userIsSuscripsion(user_id: any) {
    return this.httpClient.get(this.baseUrl + `/suscripcion/${user_id}`);
  }

  assignModulosUser(data: { modulos: any; user_id: number }) {
    return this.httpClient.post(this.baseUrl + `/modulos`, data);
  }

  getUsersPaginateNext(next: string): Observable<any> {
    // "http://bkcontrolturno.vaixs.org/public/api/informes/sucursal/3?page=2"
    return this.httpClient.get<any>(next);
  }

  listarUsuarios(
    rol: string,
    nombreUser: string,
    totalPaginacion?: number
  ): Observable<Paginated> {
    const params = new HttpParams().set('paginacion', String(totalPaginacion));
    return this.httpClient.get<Paginated>(
      this.baseUrl +
        `?rol=${rol}&term=${nombreUser}&user_id=${
          JSON.parse(localStorage.getItem('credentials')).user.id
        }`,
      { params: params }
    );
  }

  // users/modulos/{id}
  listModuleByUser(idUser: string) {
    return this.httpClient.get(this.baseUrl + `/modulos/${idUser}`);
  }

  sentPdf(data: any) {
    return this.httpClient.post(this.baseUrl + `/email`, data);
  }
}
